import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { InfoIcon, RecordingsIcon, UnmutedCameraIcon } from '@streamr/tv-ui';
import { useMemo, useRef, useState } from 'react';
import styled, { css } from 'styled-components';
import { formatDate } from '../../utils/time';
import { Anchor } from '../Anchor';
import { Button } from '../Button';
import { Frame } from '../Frame';
import { showBroadcastInfo } from '../popups/BroadcastItemInfoPopup';
export function BroadcastFrame({ broadcast, onActivateBroadcastClick, onRecordingsClick, }) {
    const { name, startsAt } = broadcast;
    const formattedTime = useMemo(() => {
        return formatDate(startsAt, 'EEEE, d LLLL · h:mmaaa');
    }, [startsAt]);
    const infoButtonAnchorRef = useRef(null);
    const [isInfoPopupOpen, setIsInfoPopupOpen] = useState(false);
    return (_jsxs(BroadcastFrameRoot, { children: [_jsxs(Details, { children: [_jsx(BroadcastTitle, { children: name }), _jsx(BroadcastStartsAt, { children: formattedTime })] }), _jsxs(Buttons, { "$hasRecordings": !!onRecordingsClick, children: [_jsx(Anchor, { ref: infoButtonAnchorRef, children: _jsx(Button, { type: "button", kind: isInfoPopupOpen ? 'primary' : 'secondary', size: "mini", shape: "pill", padding: "none", icon: _jsx(InfoIcon, { fill: "currentColor" }), onClick: () => {
                                showBroadcastInfo(broadcast, {
                                    anchorRef: infoButtonAnchorRef,
                                    onOpenPopup: () => {
                                        setIsInfoPopupOpen(true);
                                    },
                                    onClosePopup: () => {
                                        setIsInfoPopupOpen(false);
                                    },
                                });
                            } }) }), _jsx(Button, { type: "button", kind: "secondary", size: "mini", shape: "pill", padding: "none", icon: _jsx(UnmutedCameraIcon, {}), onClick: () => {
                            onActivateBroadcastClick?.();
                        } }), onRecordingsClick && (_jsx(Button, { type: "button", kind: "secondary", size: "mini", shape: "pill", padding: "none", icon: _jsx(RecordingsIcon, {}), onClick: () => {
                            onRecordingsClick?.();
                        } }))] })] }));
}
const BroadcastTitle = styled.h2 `
    font-size: var(--BroadcastTitle_FontSize, 2rem);
    line-height: 1;
    font-weight: 600;
    width: 100%;
    word-wrap: break-word;
`;
const BroadcastStartsAt = styled.div `
    margin-top: 0.75rem;
    font-size: var(--BroadcastStartsAt_FontSize, 1.25rem);
    line-height: 1.2em;
    width: 100%;
    opacity: 0.5;
    font-weight: 500;
`;
const Pad = styled.div `
    width: 100%;
    box-sizing: border-box;
    padding: 2rem;
`;
const Details = styled(Pad) `
    flex-grow: 1;
`;
const Buttons = styled(Pad) `
    flex: 0;
    display: grid;
    gap: 1rem;
    grid-template-columns: ${({ $hasRecordings }) => ($hasRecordings ? 'auto auto auto' : 'auto auto')};
    align-self: flex-end;
    width: auto;
`;
export const BroadcastFrameListTitle = styled.div `
    font-size: 1rem;
    font-weight: 500;
    line-height: 1;
    margin: 0 auto 1rem;
    max-width: 100%;
    width: var(--BroadcastFrame_Width, 21.75rem);
`;
const BroadcastFrameRoot = styled(Frame) `
    color: #ffffff;
    margin: 0 auto;
    min-width: 0;
    min-height: var(--BroadcastFrame_MinHeight, 20rem);
    padding: 0;
`;
export function BroadcastFrameList({ title, multi = false, children, }) {
    return (_jsxs(BroadcastFrameListRoot, { "$multi": multi, children: [multi && title != null && (_jsx(BroadcastFrameListTitle, { children: title })), children] }));
}
const BroadcastFrameListRoot = styled.div `
    margin: 0 auto;
    max-width: 100%;
    padding: 0 1.75rem;
    width: var(--BroadcastFrame_Width, 25.25rem);
    box-sizing: border-box;

    & + &,
    ${BroadcastFrameRoot} + ${BroadcastFrameRoot} {
        margin-top: 1.5rem;
    }

    ${({ $multi }) => $multi &&
    css `
            --BroadcastTitle_FontSize: 1.5rem;
            --BroadcastStartsAt_FontSize: 1rem;
            --BroadcastFrame_Width: 44.25rem;
            --BroadcastFrame_MinHeight: none;

            ${BroadcastFrameRoot} {
                border-radius: 2rem;
                gap: 1rem;                
                flex-direction: column;
                @media (min-width: 32rem) {
                    flex-direction: row;
                }
            }

            ${Details} {                
                padding-bottom: 0;
                @media (min-width: 32rem) {
                    padding-right: 0;
                    padding-bottom: 2rem;
                }
            }

            ${Buttons} {
                align-self: flex-end;    
                @media (min-width: 32rem) {
                    padding-left: 0;                    
                }
                
            }
        `}
`;
